import axios from "axios";

// Define a type for the response data
interface SaveInitiateTransferData {
    record_id?: string;
    // Add other fields that you expect in the response
}

// Define the return type of the function
type InitiateTransferResponse = {
    data?: SaveInitiateTransferData;
    error?: string;
} | null;

// Define the function with appropriate types for parameters and return type
export const getInitiateTransfer = async (recordId: string | null, requestedEmail: string | null): Promise<InitiateTransferResponse> => {
    try {
        const apiUrl = `${process.env.REACT_APP_PROXY_URL}/v1/initiateSignature`;
        const response = await axios.post(apiUrl, null, {
            headers: {
                Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
                "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY
            },
            params: {
                record_id: recordId ?? "", // Use recordId or an empty string
                email: requestedEmail ?? "" // Use requestedEmail or an empty string
            }
        });

        // Return the response for further handling
        return response;
    } catch (err) {
         if (axios.isAxiosError(err)) {
            return err?.response?.data;
        }
            return null;
    }
};
